export default __webpack_public_path__ + "static/media/subject-science.c8f9a640.webp";